import { createHandlerChainRunner, createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

interface Parameter{
    isShippingStateDisabledValue:boolean,
}

type HandlerType = CustomHandler<Parameter>;

export const CenSpcIsShippingDisabled: HandlerType = props =>{
    props.dispatch({
        type:"Pages/OnePageCheckout/CenSpcIsShippingDisabled",
        isShippingStateDisabledValue:props.parameter.isShippingStateDisabledValue,
    });
}

export const chain = [CenSpcIsShippingDisabled];

const cenSpcIsShippingDisabled = createHandlerChainRunner(chain, "CenSpcIsShippingDisabled");
export default cenSpcIsShippingDisabled;